import galoMonitorApi from '@galo-monitor/services/apis/galoMonitorApi'

const handleFetchRawMaterialOptions = params => galoMonitorApi
  .get('/farms/properties/activities/agricultural-inputs', { params })

const handleFetchMachineOptions = params => galoMonitorApi
  .get('/farms/properties/activities/machines', { params })

const handleFetchResponsibleOptions = params => galoMonitorApi
  .get('/farms/properties/activities/collaborating-users', { params })

export {
  handleFetchMachineOptions,
  handleFetchRawMaterialOptions,
  handleFetchResponsibleOptions
}
